/* Visionneuse de photos clientes — commune a la page d'accueil et a la page avis. */
(() => {
  let box;

  function open(src, alt) {
    if (!box) {
      box = document.createElement('dialog');
      box.className = 'ry-lightbox';
      box.innerHTML =
        '<button class="ry-lightbox__close" type="button">Close</button><img alt="">';
      document.body.appendChild(box);
      box.querySelector('.ry-lightbox__close').addEventListener('click', () => box.close());
      box.addEventListener('click', (e) => {
        if (e.target === box) box.close();
      });
    }
    const img = box.querySelector('img');
    img.src = src;
    img.alt = alt || '';
    box.showModal();
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-shot]');
    if (!btn) return;
    e.preventDefault();
    open(btn.dataset.shot, btn.querySelector('img')?.alt);
  });
})();

/* Retour en haut — le thème fait defiler un conteneur, pas le document :
   un lien vers '#' ne suffit donc pas, il faut remonter le bon scroller. */
(() => {
  function scroller(el) {
    for (let n = el.parentElement; n; n = n.parentElement) {
      const oy = getComputedStyle(n).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && n.scrollHeight > n.clientHeight) return n;
    }
    return null;
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('.ry-footer__top');
    if (!link) return;
    e.preventDefault();
    const box = scroller(link) || document.scrollingElement;
    const start = box.scrollTop;

    /* Le conteneur porte `scroll-behavior: smooth` : pour un saut sec il faut
       le neutraliser, sinon l'affectation de scrollTop reste sans effet. */
    const jump = () => {
      const kept = box.style.scrollBehavior;
      box.style.scrollBehavior = 'auto';
      box.scrollTop = 0;
      box.style.scrollBehavior = kept;
    };

    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      jump();
      return;
    }

    box.scrollTo({ top: 0, behavior: 'smooth' });
    /* Filet de securite : si l'animation n'a pas demarre, on remonte d'un coup. */
    setTimeout(() => {
      if (start > 0 && box.scrollTop === start) jump();
    }, 250);
  });
})();
